import React, { useState, useEffect, useRef } from "react";
import "../../../../css/forms.css";
import logo from "../../../../assets/images/pass-logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";

const SignUp = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isloading, setIsloading] = useState(false);

  const name = useRef();
  const email = useRef();
  const password = useRef();
  const [message, setMessage] = useState(null);
  const validateName = document.querySelector(".validate-name");
  const validateEmail = document.querySelector(".validate-email");
  const validatePassword = document.querySelector(".validate-password");
  const mybutton = document.querySelector(".secondary-btn");
  const signUpContainer = document.querySelector(".signup-container");
  const requestUrl =
    "/signin";

  let navigate = useNavigate();
  let timer1;

   const validateInputs = () => {
     if (
       name.current.value.trim() === "" ||
       email.current.value.trim() === "" ||
       password.current.value.trim() === ""
     ) {
       setMessage("All fields are required");
       validateName.classList.add("alert-validate");
       validateEmail.classList.add("alert-validate");
       validatePassword.classList.add("alert-validate");
     }
   };

  const handleSignUp = (e) => {
    e.preventDefault();

    if (
      name.current.value.trim() === "" ||
      email.current.value.trim() === "" ||
      password.current.value.trim() === ""
    ) {
      mybutton.classList.add("headshake-anim");
      setMessage("All fields are required");
      validateName.classList.add("alert-validate");
      validateEmail.classList.add("alert-validate");
      validatePassword.classList.add("alert-validate");
      return;
    } else {
      setMessage("");
      validateEmail.classList.remove("alert-validate");
      validatePassword.classList.remove("alert-validate");
      mybutton.classList.remove("headshake-anim");
    }
    setMessage(null);
   
    const requestBody = {
      name: name.current.value,
      email: email.current.value,
      password: password.current.value,
    };
    setIsloading(!isloading);
    axios
      .post(requestUrl, requestBody)
      .then((response) => {
        signUpContainer.classList.add("animate-pageleft");
        setIsloading(isloading);
        timer1 = setTimeout(() => {
          setMessage("Registration Successfull");
          navigate("/pass-account");
        }, 3000);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          signUpContainer.classList.remove("animate-pageleft");
          setIsloading(isloading);
          setMessage(error.response.data.message);
              validateEmail.classList.add("alert-validate");
              validatePassword.classList.add("alert-validate");
               mybutton.classList.add("headshake-anim");
          console.log(error.response.data.message);
        }
        else if(
          error.response.status === 403) {
             signUpContainer.classList.remove("animate-pageleft");
            setIsloading(isloading);
            setMessage(error.response.data.message);
            validateEmail.classList.add("alert-validate");
             mybutton.classList.add("headshake-anim");
          } else {
             signUpContainer.classList.remove("animate-pageleft");
            validateEmail.classList.remove("alert-validate");
            validatePassword.classList.remove("alert-validate");
             mybutton.classList.remove("headshake-anim");
          setMessage("Server not reachable");
          
        }
      });
  };

  const handleShowPass = () => {
    const password = document.getElementById("password");
    const icon = document.querySelector(".zmdi");

    setShowPassword(!showPassword);

    if (!showPassword) {
      password.setAttribute("type", "text");
      icon.classList.remove("zmdi-eye");
      icon.classList.add("zmdi-eye-off");
    } else {
      password.setAttribute("type", "password");
      icon.classList.remove("zmdi-eye-off");
      icon.classList.add("zmdi-eye");
    }
  };
  const focusFunction = () => {
    const inputName = document.querySelector(".input-name");
    const inputEmail = document.querySelector(".input-email");
    const inputPassword = document.querySelector(".input-password");

    if (name.current.value.trim() !== "") {
      inputName.classList.add("has-val");
    } else {
      inputName.classList.remove("has-val");
    }

    if (email.current.value.trim() !== "") {
      inputEmail.classList.add("has-val");
    } else {
      inputEmail.classList.remove("has-val");
    }

    if (password.current.value.trim() !== "") {
      inputPassword.classList.add("has-val");
    } else {
      inputPassword.classList.remove("has-val");
    }

    if (name.current.value.trim() !== "") {
      setMessage("");
      validateName.classList.remove("alert-validate");
    }

    if (email.current.value.trim() !== "") {
      setMessage("");
      validateEmail.classList.remove("alert-validate");
    }
    if (password.current.value.trim() !== "") {
      setMessage("");
      validatePassword.classList.remove("alert-validate");
    }
  };

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    return (()=>{
        clearTimeout(timer1);
    })
  });
  return (
    <div className="">
      <div className="">
        <div className="container">
          <div className="">
            <div className="signup-container">
              <div className="signup-inner">
                <div className="signup-form-header">
                  <img src={logo} alt="" />
                  <div className="signup-form-title">
                    <h3>Create New Account</h3>
                  </div>
                </div>

                <form className="signup-form" onSubmit={handleSignUp}>
                  <div
                    className="wrap-input-signup validate-name"
                    data-validate={message}
                  >
                    <input
                      type="text"
                      className="input-name"
                      ref={name}
                      onChange={focusFunction}
                    />
                    <span
                      className="focus-input-name"
                      data-placeholder="Name"
                    ></span>
                  </div>
                  <div
                    className="wrap-input-signup validate-email"
                    data-validate={message}
                  >
                    <input
                      type="email"
                      className="input-email"
                      ref={email}
                      onChange={focusFunction}
                    />
                    <span
                      className="focus-input-email"
                      data-placeholder="Email"
                    ></span>
                  </div>
                  <div
                    className="wrap-input-signup validate-password"
                    data-validate={message}
                  >
                    <span className="btn-show-pass" onClick={handleShowPass}>
                      <i className="zmdi zmdi-eye"></i>
                    </span>
                    <input
                      className="input-password"
                      type="password"
                      id="password"
                      ref={password}
                      onChange={focusFunction}
                    />
                    <span
                      className="focus-input-password"
                      data-placeholder="Password"
                    ></span>
                  </div>
                  {!isloading ? (
                    <button
                      type="submit"
                      className="secondary-btn"
                      onClick={validateInputs}
                    >
                      Sign Up
                    </button>
                  ) : (
                    <div className="pass-loader-container">
                      <div className="pass-loader-mini"></div>
                    </div>
                  )}
                </form>
                <div className="signin-link-lbl">
                  <label>
                    Already have an account?
                    <span>
                      <NavLink to="/signin"> Sign In</NavLink>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
